import './scss/newsletter-social.scss'
import '../../../scss/_toast.scss'

import type { WidgetAppProps, WidgetProps } from "../../../types/widget.props.ts"
import { useId } from "react"
import { Device } from "@/utils/device.ts"
import { getResourceFromS3 } from "@/utils/getResourceFromS3.ts"
import { isDev } from "@/utils/enviroment-detector.ts"
import { ListaRedes } from "@/components/widget-especifico/components/ListaRedes.tsx"
import { Form } from "@/components/widget-especifico/components/Form.tsx"

export function NewsletterSocial({ lojaNome, social, device, configuracaoSite, textosPersonalizados }: Readonly<WidgetProps>) {
    const randomId = useId()

    return (
        <div className="widget-newsletter-2">
            <div className="container flex space-around">
                <div className="news-social flex space-around">
                    {device == Device.DESKTOP && (
                        <div className="icon-social">
                            <img
                                className="lazyload lazyload-svg"
                                src={isDev() ? getResourceFromS3('/assets/global/common-icons/newsletter', 'icon-social.svg') : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='}
                                data-src={getResourceFromS3('/assets/global/common-icons/newsletter', 'icon-social.svg')}
                                width={125}
                                height={86}
                                alt="Social Newsletter"
                                title="Social Newsletter"
                                draggable={false}
                            />
                        </div>
                    )}

                    <div className="redes-sociais">
                        <div className="title-redes flex align-center">
                            {textosPersonalizados.newsletterFollowUs}
                        </div>

                        <ListaRedes social={social} lojaNome={lojaNome} />
                    </div>
                </div>

                <div className={`news-area news-form-${randomId} flex column align-center`}>
                    <span className="sub-title">{textosPersonalizados.newsletterTitle}</span>

                    <Form
                        configuracaoSite={configuracaoSite}
                        textosPersonalizados={textosPersonalizados}
                        hasFieldTelefone
                        dinformname="newsletter-widget-02"
                        className={{
                            form: `space-between field-email${(configuracaoSite.newsletterExibeNome) ? '' : ' full'}`,
                            button: "button button-medium button-primary"
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default class WidgetNewsletter02App {
    constructor(props: WidgetAppProps) {
        const el = document.getElementById(props.id)
        if (!el) return
        // @ts-expect-error ReactDOM inserido no base.html
        const root = ReactDOM.createRoot(el)
        root.render(
            <NewsletterSocial {...props} />
        )
    }
}
